import * as React from "react";
import {MouseEvent} from "react";
import {connect} from "react-redux";
import {push} from "react-router-redux";
import {SpecialsRoutes} from "../../routes";
import ActivityFeedSpecialItemComponent from "../components/ActivityFeedSpecialItemComponent";
import Special from "../../_data/models/Special";

interface Props {
    special: Special;
    toggleLike: (e: MouseEvent<HTMLElement>) => void;
}

const mapStateToProps = (state, props: Props) => {
    return {
    };
};

const mapDispatchToProps = (dispatch, props: Props) => {
    const {special} = props;
    return {
        viewSpecial: () => {
            dispatch(push(SpecialsRoutes.show(special.id)))
        }
    }
};

const ActivityFeedSpecialItemContainer = connect<any, any, Props>(mapStateToProps, mapDispatchToProps)(ActivityFeedSpecialItemComponent);
export default ActivityFeedSpecialItemContainer;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/containers/ActivityFeedSpecialItemContainer.tsx